<template lang="html">
  <div class="live">
    <!-- <h3>直播</h3> -->
    <div class="panel-box" v-if="begin.length">
      <div class="panel-box-header">
        <span class="live-box-header-desc">即将开播</span>
        <div class="live-box-header-circle"></div>
      </div>
      <div class="panel-item" @click="goLive(item.url, item.modelSrc)" v-for="item of begin" :key="item.id">
        <img v-lazy="`${item.dbsCoverUrl}?x-oss-process=image/resize,fill,w_320,h_180`" alt="">
        <div class="panel-item-details">
          <h5>{{item.dbsRoomName}}</h5>
          <span>{{item.valueTime}}</span>
        </div>
      </div>
    </div>
    <div class="panel-box" v-if="end.length" :style="{ 'margin-bottom': isAndroid ? '0' : '31px' }">
      <div class="panel-box-header">
        <span class="live-box-header-desc">已结束</span>
        <div class="live-box-header-circle circle-end"></div>
      </div>
      <div class="panel-item" @click="goLive(item.url, item.modelSrc)" v-for="item of end" :key="item.id">
        <img v-lazy="`${item.dbsCoverUrl}?x-oss-process=image/resize,fill,w_320,h_180`" alt="">
        <div class="panel-item-details">
          <h5>{{item.dbsRoomName}}</h5>
          <span>{{item.valueTime}}</span>
        </div>
      </div>
    </div>
<!--    <div v-show="modelSrc" @click="closeModelSrc" class="modelSrc">-->
<!--      <img v-lazy="modelSrc">-->
<!--    </div>-->
  </div>
</template>

<script>
import { get } from '../../utils/request'
import { APIHOST, safeHeight } from '../../utils/config'
import { get as getUser } from '../../utils/token'
import { isAndroid } from '../../utils/utils'
import { liverIsEnd } from '../../utils/date'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('tabbar')
export default {
  data () {
    return {
      begin: [],
      end: [],
      isAndroid: isAndroid(),
      safeHeight: safeHeight,
      modelSrc: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.updateTabIndex('live')
    })
  },
  mounted () {
    this.getAllLiveList(0, (array) => {
      this.begin = array.filter(item => liverIsEnd(item.endTime))
      const end = array.filter(item => !liverIsEnd(item.endTime))
      this.end = end
      this.getAllLiveList(2, (_array) => {
        let _end = this.end
        _end = [..._end, ..._array]
        this.end = _end
      })
    })
  },
  methods: {
    ...mapActions({
      updateTabIndex: 'updateTabIndex'
    }),
    getAllLiveList (state, callback) {
      const promise = get({
        url: `/dbs/liveChannels?status=${state}`,
        baseURL: APIHOST
      })
      promise.then(res => {
        const { status, data: { data } } = res
        if (Object.is(status, 200)) {
          const array = data.map(item => {
            item.key = item.id
            return item
          })
          callback(array)
        }
      })
    },
    closeModelSrc () {
      this.modelSrc = ''
    },
    goLive (url, modelSrc) {
      if (url) {
        const user = getUser('user')
        window.location = `${url}&fromCas=true&username=${user.username}`
      }
      if (modelSrc) {
        // this.modelSrc = modelSrc
        window.location = modelSrc
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.live {
  background: #fff;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  height: calc(1000vh - 50px);
  h3 {
    text-align: center;
    padding: 9px 0;
    margin-bottom: 16px;
    font-size:17px;
    font-family:SFProText-Semibold,SFProText;
    font-weight:600;
    color:rgba(0,0,0,1);
    line-height:22px;
    border-bottom: 1px solid #E2E2E2;
  }
  .panel-box {
    margin: 0 auto 0;
    padding-top: 24px;
    width: 91.47%;
    &:last-child {
      margin-bottom: 31px;
    }
    .panel-box-header {
      display: flex;
      position: relative;
      .live-box-header-desc {
        height:27px;
        font-size:20px;
        font-family:AlibabaPuHuiTi-Medium,AlibabaPuHuiTi;
        font-weight: bold;
        color:rgba(0,0,0,1);
        line-height:27px;
        letter-spacing: 1px;
        margin-right: 8px;
      }
      .live-box-header-circle {
        box-sizing: border-box;
        width:10px;
        height:10px;
        border-radius: 50%;
        border: 2px solid #18CC9F;
        position: absolute;
        left: 92px;
        bottom: 5px;
      }
      .circle-end {
        left: 70px;
      }
    }
    .panel-item {
      display: flex;
      width: 100%;
      height:90px;
      margin: 23px auto 0 auto;
      justify-content: space-between;
      padding-bottom: 24px;
      border-bottom: 1px dashed #E2E2E2;
      img {
        width: 42.66vw;
        height:90px;
        box-shadow:0px 2px 12px 0px rgba(0,0,0,0.1);
      }
      .panel-item-details {
        width: 46.66vw;
        height:90px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h5 {
          font-size:14px;
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight:600;
          color:rgba(51,51,51,1);
          line-height:22px;
          letter-spacing: 0.28px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        span {
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(136,136,136,1);
          line-height:17px;
        }
      }
    }
  }
  .modelSrc {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9;
    background: rgba(0, 0, 0, 1);
    box-sizing: border-box;
    img {
      width: 100%;
      height: auto;
      border-radius: 10px;
      margin-top: 2vh;
    }
  }
}
</style>
